import React, {Component} from 'react';
import {connect} from 'react-redux';
import FlightCard from './FlightCard';
import FlightsPagination from './FlightsPagination';
import BrandedSpinner from '../common/BrandedSpinner';
import Translator from '../../helpers/Translator';
import {DOMAIN} from '../FlightsContainer';
import {PER_PAGE} from '../../actions/FlightsActions';

class FlightsList extends Component {

    renderList() {
        if (this.props.flights.loading === false
            && this.props.flights.flights.length === 0
            && this.props.flights.importEnded === true
        ) {
            return <div className="fs-empty">
                <div className="fs-empty__icon">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="7"/>
                        <path d="m21 21-4.3-4.3"/>
                        <path d="M8 11h6"/>
                    </svg>
                </div>
                <div className="fs-empty__title">
                    {this.translator.trans('We are sorry but there are no results found by given search criteria')}
                </div>
                <div className="fs-empty__text">
                    {this.translator.trans('Please make some changes and search again.')}
                </div>
                <div className="fs-empty__contact">
                    {this.translator.trans('You can also write to us about what you are looking for ')}:{` `}
                    <a href={`mailto:${this.props.agentEmail}`}>{this.props.agentEmail}</a>
                </div>
            </div>;
        }

        const start = (this.props.flights.viewPage - 1) * PER_PAGE;

        return this.props.flights.flights.slice(start, start + PER_PAGE).map((flight, offset) => {
            const index = start + offset;
            return <FlightCard key={index} index={index} flight={flight}/>
        });
    }

    renderRecommended() {
        if (this.props.recommended === null || this.props.recommended._id === this.props.cheapest._id) {
            return null;
        }

        const filters = Object.keys(this.props.filterGroups);
        for (let i = 0; i < filters.length; i++) {
            if (this.props.filterGroups[filters[i]].enabled) {
                return null;
            }
        }

        if (this.props.cheapest && this.props.cheapest.length > 0) {
            for (let i = 0; i < this.props.cheapest.length; i++) {
                if (this.props.recommended._id === this.props.cheapest[i]._id) {
                    return null;
                }
            }
        }

        return <FlightCard key='recommended' index='popular' flight={this.props.recommended}/>;
    }

    shouldBeOpaque() {
        return (this.props.overlaying.toggle
            && !(this.props.flights.importEnded && this.props.flights.flights.length === 0));
    }

    render() {
        this.translator = new Translator(this.props.translator, DOMAIN);
        const flights = this.props.flights;
        // genuinely searching: the import stream is still running
        const streaming = !flights.loading && !flights.importEnded && !flights.cachedResults;
        // a filter/sort request is in flight
        const filtering = !!(this.props.overlaying && this.props.overlaying.toggle);

        return (
            <div>
                {/* outside the dimmed wrapper so it stays fully visible; the
                    sidebar mini is hidden on mobile, this one isn't */}
                {(streaming || filtering) &&
                    <BrandedSpinner
                        title={this.translator.trans('Searching for flights offers')}
                        subtitle={`${this.translator.trans('Found flights')}: ${flights.count}`}
                    />
                }
                <div className={this.shouldBeOpaque() ? 'overlay-opaque' : ''}>
                    <div className={this.shouldBeOpaque() ? 'overlay' : ''}/>
                    {this.renderRecommended()}
                    {this.renderList()}
                    <FlightsPagination/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        flights: state.FlightsReducer,
        importEnded: state.FlightsReducer.importEnded,
        agentEmail: state.ParametersReducer.parameters.agentEmail,
        overlaying: state.FlightsReducer.overlaying,
        recommended: state.FlightsReducer.recommended,
        cheapest: state.FlightsReducer.cheapest,
        filterGroups: state.FilterGroupsReducer.groups,
        sortType: state.SortReducer.field,
    }
}

export default connect(mapStateToProps)(FlightsList);



// WEBPACK FOOTER //
// ./src/components/flights/FlightsList.js